import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { css } from './css.esm.js';
import { createParser } from '../styles-system/system-core.esm.js';
import { EMPTY_OBJECT, memoizedGet } from '../utils/object.esm.js';

function styleVariant (_ref) {
  var scale = _ref.scale,
    _ref$prop = _ref.prop,
    prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
    _ref$variants = _ref.variants,
    variants = _ref$variants === void 0 ? EMPTY_OBJECT : _ref$variants,
    key = _ref.key;
  var sx;
  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css(memoizedGet(scale, value, null))(props);
    };
  } else {
    sx = function sx(value, scale) {
      return memoizedGet(scale, value, null);
    };
  }
  sx.scale = scale || key;
  sx.defaults = variants;
  var config = _defineProperty({}, prop, sx);
  var parser = createParser(config);
  return parser;
}

export default styleVariant;
//# sourceMappingURL=variant.esm.js.map
